import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    path: null,
    prevpath: null,
    returnToPrev: false,
};

const pathSlice = createSlice({
    name: "path",
    initialState,
    reducers: {
        setPathToAuthentication(state, action) {
            state.path = "/authentication";
        },
        setPathToRegistration(state, action) {
            state.path = "/registration";
        },
        setPathToSelfShipment(state, action){ 
            if(!action.payload.id) {
                return
            }

            const shipmentID = action.payload.id
            
            state.path = `/shipments/${shipmentID}`
        },
        setPathToHome(state, action) {
            state.path = "/"
        },
        setPathToShipments(state, action) {
            state.path = "/shipments"
        },
        setPrevPath(state, action) {
            let prevpath = action.payload.prevpath
            if(!prevpath)
                return
            state.prevpath = prevpath
        },
        clearPath(state){ 
            state.path = null
        },
        setPathToProfile(state, action) {
            state.path = "/profile"
        },
        returnToPrevPath(state) {
            if(state.prevpath) {
                state.path = state.prevpath
            } else {
                state.path = "/"
            }
            state.prevpath = null
            state.returnToPrev = true
        },
        setRetrunToPrevPath(state, action) {
            let {returnToPrevPath} = action.payload
            state.returnToPrev = returnToPrevPath
        }
    },
});

export const {
    setPathToAuthentication,
    setPathToRegistration,
    setPathToSelfShipment,
    setPathToProfile,
    returnToPrevPath,
    setPrevPath,
    setPathToHome,
    setRetrunToPrevPath,
    clearPath,
    setPathToShipments,
} = pathSlice.actions;

export const selectPath = (state) => state.path.path;
export const selectReturnToPrevPath = (state) => state.path.returnToPrev;

export default pathSlice.reducer;
